module.exports = __webpack_public_path__ + "static/media/icon_file_dex.0911e73d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_file_dex.svg
// module id = 146
// module chunks = 0